import { cn } from "@/lib/utils";
import Icon, { IconIdType } from "@/components/ui/Icon";
import { memo } from "react";
import { Typography } from "@/components/ui/typography";

export type HelpCardProps = {
  title?: string;
  iconId: IconIdType;
  iconSizes?: {
    width?: number;
    height?: number;
  } | null;
} & React.ComponentProps<"div">;

const HelpCard = ({
  iconId,
  title,
  iconSizes = {},
  className,
}: HelpCardProps) => {
  return (
    <div
      className={cn(
        "flex px-5 py-6.5 md:px-5 md:py-7.5 border bg-white border-neutral-200 rounded-3xl overflow-hidden lg:rounded-2xl md:border-transparent transition-[border-color,background-color] hover:border-blue-500 hover:bg-[#eaeffb]",

        className
      )}
    >
      <div className="flex-auto min-w-0 flex flex-col items-start md:items-center md:justify-content">
        <Icon id={iconId} className="shrink-0 text-blue-500 w-12 h-12" style={{...iconSizes}} />
        <Typography
          variant="titleMd"
          className="mt-3 text-semantic-text-primary font-semibold md:text-gray-800 md:text-xl md:leading-[150%] md:text-center"
          asChild
        >
          <h3>{title}</h3>
        </Typography>
      </div>
    </div>
  );
};

export default memo(HelpCard);
